import moment from 'moment'
moment.locale('id')

import { formatIndexDate } from '@/helpers/tzDate'
import { formatDateFields } from '../constants/formatFields'

export function formatDate(value) {
  const date = formatIndexDate(value).date
  const time = formatIndexDate(value).time
  if (date == '-' || time == '-') return '-'
  return `${date} ${time}`
}

export function formatValues(key, value) {
  if (formatDateFields.includes(key)) return formatDate(value)
  return value || (typeof value === 'number' ? value : '-')
}
